import React from 'react';
import Reflux from 'reflux';
import AlertBarStore from 'flux/stores/AlertBarStore';
import classNames from 'classnames';

/**
 * Cuesheet container that is aware of alert bar and pushes content down accordingly
 *
 */
const AlertBarAwareContainer = React.createClass({
  mixins: [Reflux.connect(AlertBarStore, 'alert')],

  displayName: 'AlertBarManaged',

  render() {
    const { children, className } = this.props;

    const { alert } = this.state;

    let fixed = true;

    if (alert && typeof alert.get('fixed') !== 'undefined') {
      fixed = alert.get('fixed');
    }
    const pushContentDown = !fixed;
    const style = {
      top: pushContentDown ? '30px' : 0,
    };

    return (
      <div className={classNames('show-wrapper', className)} style={style}>
        {children}
      </div>
    );
  },
});

export default AlertBarAwareContainer;
